import styles from './AiRecommendations.module.css';

const OPTIONS = [
  { value: 'applicants', label: '지원자' },
  { value: 'ai', label: 'AI 추천 배우' },
];

/** 지원자 관리 화면 상단의 '지원자 / AI 추천 배우' 전환 */
export default function ApplicantViewSwitch({ value, onChange }) {
  return (
    <div className={styles.viewSwitch} role="tablist" aria-label="보기 전환">
      {OPTIONS.map(o => (
        <button
          key={o.value}
          type="button"
          role="tab"
          aria-selected={value === o.value}
          className={`${styles.viewSwitchBtn} ${value === o.value ? styles.viewSwitchBtnActive : ''}`}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
